function CardIcon({ size = '21', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.087 3.19922H3.08698C1.67031 3.19922 0.586975 4.28255 0.586975 5.69922V15.6992C0.586975 17.1159 1.67031 18.1992 3.08698 18.1992H18.087C19.5036 18.1992 20.587 17.1159 20.587 15.6992V5.69922C20.587 4.28255 19.5036 3.19922 18.087 3.19922ZM3.08698 4.86589H18.087C18.587 4.86589 18.9203 5.19922 18.9203 5.69922V8.19922H2.25364V5.69922C2.25364 5.19922 2.58698 4.86589 3.08698 4.86589ZM3.08698 16.5326H18.087C18.587 16.5326 18.9203 16.1992 18.9203 15.6992V9.86589H2.25364V15.6992C2.25364 16.1992 2.58698 16.5326 3.08698 16.5326Z"
        fill="url(#paint0_linear)"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="21"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.087 3.19922H3.08698C1.67031 3.19922 0.586975 4.28255 0.586975 5.69922V15.6992C0.586975 17.1159 1.67031 18.1992 3.08698 18.1992H18.087C19.5036 18.1992 20.587 17.1159 20.587 15.6992V5.69922C20.587 4.28255 19.5036 3.19922 18.087 3.19922ZM3.08698 4.86589H18.087C18.587 4.86589 18.9203 5.19922 18.9203 5.69922V8.19922H2.25364V5.69922C2.25364 5.19922 2.58698 4.86589 3.08698 4.86589ZM3.08698 16.5326H18.087C18.587 16.5326 18.9203 16.1992 18.9203 15.6992V9.86589H2.25364V15.6992C2.25364 16.1992 2.58698 16.5326 3.08698 16.5326Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <rect
          x="0.586975"
          y="0.699219"
          width="20"
          height="20"
          fill="url(#paint1_linear)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-9.41302"
          y1="10.6992"
          x2="4.98698"
          y2="29.8992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="-9.41302"
          y1="10.6992"
          x2="10.587"
          y2="30.6992"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CardIcon;
